import { render } from "./App.vue?vue&type=template&id=3997e92d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3997e92d&lang=scss"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__